let util = {

};

util.title = function (title) {
    title = title ? title + ' - 明我食疗管理后台' : '明我食疗管理后台';
    window.document.title = title;
};

util.priceUtils=function(price){
    let json={
        price:price,
    }
    var startIndex = json.price.indexOf(".");
    if(startIndex==-1){
        json.price=(price+'00')*1;
    }else{
        var yuan = json.price.substring(0,startIndex);
        var fen = json. price.substring(startIndex+1,json.price.length);
        if(fen.length==1){
            fen += "0";
        }
        json.price=(yuan +fen)*1;
    }
    return json.price;
};

util.showWeekFirstDay = function () {     //本周第一天
    var Nowdate = new Date();     
    var WeekFirstDay = new Date(Nowdate-(Nowdate.getDay() - 1)*86400000); 
    let M = Number(WeekFirstDay.getMonth()) + 1 
    let MM = M > 10 ? M : '0' + M
    let d = WeekFirstDay.getDate(); 
    let dd = d > 10 ? d : '0' + d
    return WeekFirstDay.getFullYear() + "-"  + MM + "-" +  dd + " 00:00:00"
};

util.showWeekLastDay = function () {     //本周最后一天
    var Nowdate=new Date();     
    var WeekFirstDay=new Date(Nowdate-(Nowdate.getDay()-1)*86400000);     
    var WeekLastDay=new Date((WeekFirstDay/1000+6*86400)*1000);     
    let M = Number(WeekLastDay.getMonth())+1 
    let MM = M > 10 ? M : '0' + M    
    let d = WeekLastDay.getDate(); 
    let dd = d > 10 ? d : '0' + d
    return WeekLastDay.getFullYear() + "-"+ MM +"-" + dd + " 23:59:59"
};
util.currentMonth = function () { // 本月第一天以及当天
    let Nowdate = new Date();     
    let yy = Nowdate.getFullYear()
    let MonthFirstDay = new Date(Nowdate.getFullYear(),Nowdate.getMonth(),1);     
    let M = Number(MonthFirstDay.getMonth()) + 1  
    let MM = M > 10 ? M : '0' + M
    let s_d = MonthFirstDay.getDate() > 10 ? MonthFirstDay.getDate() : '0' + (MonthFirstDay.getDate())
    let e_d = Nowdate.getDate() > 10 ? Nowdate.getDate() : '0' + (Nowdate.getDate())
    return {
        start: yy + '-' + MM + '-' + s_d + ' 00:00:00',
        end: yy + '-' + MM + '-' +  e_d + ' 23:59:59',
    }
}

util.getDaysBetween = function (dateString1, dateString2){
    let star = util.formatTimestamp(dateString1, "yyyy-MM-dd")
    let end = util.formatTimestamp(dateString2, "yyyy-MM-dd")
    let startDate = Date.parse(star);
    let endDate = Date.parse(end);
    // if (startDate > endDate){
    //     return 0;
    // }
    // if (startDate == endDate){
    //     return 1;
    // }
    let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    return  days;
}

util.formatTimestamp = function (timestamp, format) {
    if (!timestamp) return;
    return util.formatDate(new Date(timestamp), format);
};

util.formatDate = function (date, format) {
    if (!date || !(date instanceof Date)) {
        return date;
    }
    let formatted = format || 'yyyy-MM-dd hh:mm:ss';

    var map = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "h+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(formatted)) {
        let value = date.getFullYear().toString().substr(4 - RegExp.$1.length);
        formatted = formatted.replace(RegExp.$1, value);
    }
    for (var key in map) {
        if (new RegExp("(" + key + ")").test(formatted)) {
            let value = map[key].toString();
            if (RegExp.$1.length != 1) {
                value = ("00" + value).substr(value.length);
            }
            formatted = formatted.replace(RegExp.$1, value);
        }
    }
    return formatted;
};
util.validateEmptys=(rule,value, callback,msg)=> {
    if (value.replace(/^(\s|\u00A0)+/,'').replace(/(\s|\u00A0)+$/,'')=='') {
        callback(new Error(msg));
    } else {
        callback();
    }
};
var vcity={ 11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
    21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",
    33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",
    42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",
    51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",
    63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"
};
util.validateCard=(rule,value,callback)=> {
    if (!util.checkCard(value)) {
        callback(new Error('身份证输入有误，请重新输入!'));
    } else {
        callback();
    }
};
util.checkCard = function(obj)
{
    //var card = document.getElementById('card_no').value;
    //是否为空
    // if(card === '')
    // {
    //  return false;
    //}
    //校验长度，类型
    if(util.isCardNo(obj) === false)
    {
        return false;
    }
    //检查省份
    if(util.checkProvince(obj) === false)
    {
        return false;
    }
    //校验生日
    if(util.checkBirthday(obj) === false)
    {
        return false;
    }
    //检验位的检测
    if(util.checkParity(obj) === false)
    {
        return false;
    }
    return true;
};
//检查号码是否符合规范，包括长度，类型
util.isCardNo = function(obj)
{
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)|(^\d{17}(\d|x)$)/;
    if(reg.test(obj) === false)
    {
        return false;
    }
    return true;
};
//取身份证前两位,校验省份
util.checkProvince = function(obj)
{
    var province = obj.substr(0,2);
    if(vcity[province] == undefined)
    {
        return false;
    }
    return true;
};
//检查生日是否正确
util.checkBirthday = function(obj)
{
    var len = obj.length;
    //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if(len == '15')
    {
        var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
        var arr_data = obj.match(re_fifteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date('19'+year+'/'+month+'/'+day);
        return util.verifyBirthday('19'+year,month,day,birthday);
    }
    //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if(len == '18')
    {
        var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})(([0-9]|X)|([0-9]|x))$/;
        var arr_data = obj.match(re_eighteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date(year+'/'+month+'/'+day);
        return util.verifyBirthday(year,month,day,birthday);
    }
    return false;
};
//校验日期
util.verifyBirthday = function(year,month,day,birthday)
{
    var now = new Date();
    var now_year = now.getFullYear();
    //年月日是否合理
    if(birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day)
    {
        //判断年份的范围（3岁到100岁之间)
        var time = now_year - year;
        if(time >= 0 && time <= 130)
        {
            var birthday_ = (year+"-"+month+"-"+day);
            return true;
        }
        return false;
    }
    return false;
};
//校验位的检测
util.checkParity = function(obj)
{
    //15位转18位
    obj = util.changeFivteenToEighteen(obj);
    var len = obj.length;
    if(len == '18')
    {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0, i, valnum;
        for(i = 0; i < 17; i ++)
        {
            cardTemp += obj.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[cardTemp % 11];
        if (valnum == obj.substr(17, 1))
        {
            return true;
        }
        return false;
    }
    return false;
};
//15位转18位身份证号
util.changeFivteenToEighteen = function(obj)
{
    if(obj.length == '15')
    {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0, i;
        obj = obj.substr(0, 6) + '19' + obj.substr(6, obj.length - 6);
        for(i = 0; i < 17; i ++)
        {
            cardTemp += obj.substr(i, 1) * arrInt[i];
        }
        obj += arrCh[cardTemp % 11];
        return obj;
    }
    return obj;
};

util.numAdd = function(a,b) { //加
    var c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (util.mul(a, e) + util.mul(b, e)) / e;
}
util.sub = function(a, b) { //减
    var c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (util.mul(a, e) - util.mul(b, e)) / e;
}
util.accMul = function(a, b) { // 浮点相乘
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) {}
    try {
        c += e.split(".")[1].length;
    } catch (f) {}
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}
util.mul = function(a, b) { // 浮点相乘
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) {}
    try {
        c += e.split(".")[1].length;
    } catch (f) {}
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}

util.except = function(a, b) { //除
    var c, d, e = 0,
        f = 0;
    try {
        e = a.toString().split(".")[1].length;
    } catch (g) {}
    try {
        f = b.toString().split(".")[1].length;
    } catch (g) {}
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), util.mul(c / d, Math.pow(10, f - e));
}


// 手机号码校验
util.isMobile = function (str) {
    return (/^(([1][3,4,5,6,7,8,9][0-9]{9})|(853[0-9]{8})|(886[0-9]{8})|(852[0-9]{8}))$/).test(str)
}
// 座机号码校验
util.isTel = function (str) {
    return (/^0\d{3,4}-?\d{7,8}$/).test(str)
}
// 密码6-12位字母数字组合
util.isPassWord = function (str) {
    return (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/).test(str)
}
// url校验
util.isUrl = function (str) {
    // return (/^(?:http(s)?:\/\/)?(\w+\.){1,3}(com(\.cn)?|cn|net|info|org|us|tk)\b/).test(str)
    return (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/).test(str)
}

util.genderChange = function(val) {
    let list = { 'LADY': '女', 'MAN': '男', 'UNKNOWN':'未知', 'nul': '--' }
    return list[val]
}
util.offsetTop = function(el){ //元素相对body的高度
    let top = null;
    let elPar = el ? el.offsetParent : 0;
    top += el ? el.offsetTop : 0;
    while (elPar) {
      if (navigator.userAgent.indexOf("MSIE 8.0") == -1) //若不是IE8，则需要加上offsetParent的clientLeft和clientTop
      {
        top += elPar.clientTop;
      }           
      top += elPar.offsetTop;
      elPar = elPar.offsetParent;
    }
    return top;
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js